const fetchJobData = async (jobId) => {
  const url = `/nonprod/analyze/async/${jobId}`;
  const response = await callMethod(url, "GET");

  if (!response.ok) {
    throw new Error(`Error fetching job status: ${response.statusText}`);
  }

  return await response.json();
};

const fetchJobHistory = async () => {
  const response = await callMethod("/nonprod/review/user", "GET");

  if (!response.ok) {
    throw new Error(`Error fetching job history: ${response.statusText}`);
  }

  return await response.json();
};

const fetchRequestAnalysis = async (fileName, analysis) => {
  const url = new URL("/nonprod/analyze/async/", window.location.href);

  url.searchParams.append("file-name", fileName);
  url.searchParams.append("analysis", analysis);

  const response = await callMethod(url.toString(), "GET");

  if (!response.ok) {
    const error_msg = await response.json();
    console.error(`Error starting analysis: ${JSON.stringify(error_msg)}`);
    throw new Error();
  }

  return await response.json();
};

const fetchAuthentToken = async (loginData) => {
  const response = await callMethod("/nonprod/auth/login", "POST", loginData);
  if (!response.ok) {
    throw new Error("Login failed");
  }

  return await response.json();
};

const fetchUserDetails = async (userId) => {
  const url = `/nonprod/analyze/user/${userId}`;
  const response = await callMethod(url, "GET");

  if (!response.ok) {
    throw new Error(`Error fetching user details: ${response.statusText}`);
  }

  return await response.json();
};

const renewJobFetchUrl = async (jobId) => {
  const url = `/nonprod/analyze/async/${jobId}`;
  const response = await callMethod(url, "PUT");

  if (!response.ok) {
    throw new Error(`Error renewing job fetch URL: ${response.statusText}`);
  }

  return await response.json();
}

const callMethod = async (url, method, body = null) => {
  const authentHeader = localStorage.getItem("authToken")
    ? `Bearer ${localStorage.getItem("authToken")}`
    : null;

  const response = await fetch(url, {
    method: method,
    headers: {
      Authorization: authentHeader,
      "Content-Type": "application/json",
      "Cache-Control": "max-age=0, must-revalidate, no-cache, no-store",
      Pragma: "no-cache", // For older HTTP/1.0 servers
      Expires: "0", // Ensures the request is always fresh
    },
    body: body && JSON.stringify(body),
  });

  return response;
};

const parseFetchUrls = (fetchUrls) => {
  if (typeof fetchUrls !== "string") {
    return fetchUrls;
  }

  try {
    return JSON.parse(fetchUrls);
  } catch (error) {
    console.error("Error parsing fetch URLs:", error);
    return [];
  }
};

const selectDownloadUrls = (fetchUrls, analysis) => {
  if (!fetchUrls || fetchUrls.length === 0) {
    return null;
  }

  // analysis is a string and it has a "lineout" in lowercase
  const is_lineout = analysis && analysis.toLowerCase().includes("lineout");
  const is_tracking = analysis && analysis.toLowerCase().includes("tracking");
  const is_reviewed = fetchUrls.find((url) => url.toLowerCase().includes("reviewed"));

  if (is_lineout) {

    if (!is_reviewed) {
      // If lineout analysis and no reviewed URL, return the first URL
      return null;
    }

    // If more than one URL
    // - Url are structured as: <...>/filename.extension?....
    // - find the first URL that contains ".xml" in filename.extension
    const url = fetchUrls.find((url) => {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname; // Get the path part of the URL

      if (pathname.endsWith(".xml")) {
        return true;
      }
    });

    // const resultFileName = result ? new URL(result).pathname.split("/").pop() : null;
    // console.log("Selected lineout URL:", result, "Filename:", resultFileName);
    const result = url || null;
    return result;
  }

  if (is_tracking) {
    // If tracking analysis: -> the result might be a .csv or a json
    // -> find the first URL that contains ".json" that is not "out.json"
    // -> else the result is a .parquet file
    // -> else find the first .csv URL
    // display result file names:
    for (let i = 0; i < fetchUrls.length; i++) {
      const urlObj = new URL(fetchUrls[i]);
      const pathname = urlObj.pathname;
      const filename = pathname.split("/").pop();
    }

    const jsonUrl = fetchUrls.find((url) => url.includes(".json") && !url.includes("out.json"));
    if (jsonUrl) {
      return jsonUrl;
    }

    const parquetUrl = fetchUrls.find((url) => url.includes(".parquet"));
    if (parquetUrl) {
      return parquetUrl;
    }

    const csvUrl = fetchUrls.find((url) => url.includes(".csv"));
    const result = csvUrl || null;
  }

  // If more than one URL:
  // - find the first URL that does not contain "out.json"
  // - if none found, return null
  const url = fetchUrls.find((url) => !url.includes("out.json"));
  const result = url || null;
  return result;
};

const parseAndSelectUrlOrNull = (fetchUrls, analysis) => {
  const listUrls = parseFetchUrls(fetchUrls);
  return selectDownloadUrls(listUrls, analysis);
};

const fetchVideoUrl = async (jobId) => {
  const url = `/nonprod/analyze/video/${jobId}`;
  const response = await callMethod(url, "GET");

  if (!response.ok) {
    throw new Error(`Error fetching video URL: ${response.statusText}`);
  }

  return await response.json();
};

export {
  fetchJobData,
  fetchJobHistory,
  fetchRequestAnalysis,
  fetchAuthentToken,
  fetchUserDetails,
  renewJobFetchUrl,
  fetchVideoUrl,
  callMethod,
  parseAndSelectUrlOrNull,
};
